// @owners { team: patients }
import { useEffect, useRef } from 'react';
import { getOrderAddressId } from '~shared/features/checkout/selectors/getOrder';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useAnalytics, usePrevious } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useSelectorShared } from '~shared/store';

export const useTrackAddressSelection = () => {
  const { trackEvent } = useAnalytics();
  const isEditingOrder = useSelectorShared(getIsEditingExistingOrder);
  const orderAddressID = useSelectorShared(getOrderAddressId);
  const originalAddressID = useRef(orderAddressID);
  const previousAddressID = usePrevious(orderAddressID);

  // 🐾 track when the address is auto-selected initially
  useEffect(() => {
    if (!originalAddressID.current) return;
    trackEvent({
      event: EVENTS.CHECKOUT__ADDRESS_SELECTED,
      params: {
        'auto-selected': true,
        address_id: originalAddressID.current,
        origin: isEditingOrder ? 'edit delivery' : 'checkout',
      },
    });
  }, [isEditingOrder, trackEvent]);

  // 🐾 track when the patient selects a different address
  useEffect(() => {
    if (previousAddressID && previousAddressID !== orderAddressID) {
      trackEvent({
        event: EVENTS.CHECKOUT__ADDRESS_SELECTED,
        params: {
          'auto-selected': false,
          address_id: orderAddressID,
          origin: isEditingOrder ? 'edit delivery' : 'checkout',
        },
      });
    }
  }, [isEditingOrder, orderAddressID, previousAddressID, trackEvent]);
};
